import React from 'react';
import PaymentExportDetailsPaymentExportsTab from '../../Operations/PaymentExport/AllExport/PaymentExportDetailsPaymentExportsTab';
import PendingApprovalTpJobTab from '../TpEvaluatorTpJobPayments/ThirdPartyJobPayments/PendingApprovalTpJobTab';
import AllTpJobPaymentsTab from '../TpEvaluatorTpJobPayments/ThirdPartyJobPayments/AllTpJobPaymentsTab';
import PendingReviewTpJobTab from '../TpEvaluatorTpJobPayments/ThirdPartyJobPayments/PendingReviewTpJobTab';
import PendingApprovalVatTab from '../../Evaluator/EvaluatorAdmin/EvaluatorPayments/PendingApprovalVatTab';

export default class RelatedTpEvaluatorTpJobPaymentsWindowDescription {
  static getTitle() {
    return `Related Evaluator Payments (Bravo Evaluator ID: ${
      RelatedTpEvaluatorTpJobPaymentsWindowDescription.getFilterParameters()?.tpEvaluatorId
    })`;
  }

  static getTabs() {
    return [
      {
        label: 'Exported Payments',
        id: 'exportedpayments',
        icon: 'fa-solid fa-memo-circle-info',
        component: (
          <PaymentExportDetailsPaymentExportsTab
            evaluatorId={RelatedTpEvaluatorTpJobPaymentsWindowDescription.getFilterParameters()?.evaluatorId}
            ieStatusCode='1'
            showActionButtonRow={false}
          />
        ),
      },
      {
        label: 'Pending Approval',
        id: 'pendingapproval',
        icon: 'fa-solid fa-memo-circle-info',
        component: (
          <PendingApprovalTpJobTab
            tpEvaluatorId={RelatedTpEvaluatorTpJobPaymentsWindowDescription.getFilterParameters()?.tpEvaluatorId}
          />
        ),
      },
      {
        label: 'Pending Review',
        id: 'pendingreview',
        icon: 'fa-solid fa-memo-circle-info',
        component: (
          <PendingReviewTpJobTab
            tpEvaluatorId={RelatedTpEvaluatorTpJobPaymentsWindowDescription.getFilterParameters()?.tpEvaluatorId}
          />
        ),
      },
      {
        label: 'Pending Approval (VAT)',
        id: 'pendingapprovalvat',
        icon: 'fa-solid fa-memo-circle-info',
        component: (
          <PendingApprovalVatTab
            tpEvaluatorId={RelatedTpEvaluatorTpJobPaymentsWindowDescription.getFilterParameters()?.tpEvaluatorId}
          />
        ),
      },
      {
        label: 'All Payments',
        id: 'allpayments',
        icon: 'fa-solid fa-memo-circle-info',
        component: (
          <AllTpJobPaymentsTab
            tpEvaluatorId={RelatedTpEvaluatorTpJobPaymentsWindowDescription.getFilterParameters()?.tpEvaluatorId}
          />
        ),
      },
    ];
  }

  static getFilterParameters() {
    return null;
  }
}
